import React, { useEffect, useState, useRef } from 'react';
import { HelpCircleIcon } from 'lucide-react';
interface InfoTooltipProps {
  text: string;
}
export const InfoTooltip = ({
  text
}: InfoTooltipProps) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const tooltipRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target as Node)) {
        setShowTooltip(false);
      }
    };
    if (showTooltip) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showTooltip]);
  return <div className="relative inline-block" ref={tooltipRef} data-id="element-105">
      <button type="button" onClick={() => setShowTooltip(!showTooltip)} className="text-gray-400 hover:text-gray-600 transition-colors ml-1" data-id="element-106">
        <HelpCircleIcon className="h-4 w-4" data-id="element-107" />
      </button>
      {showTooltip && <div className="absolute left-0 top-6 z-10 w-64 bg-white border border-gray-200 rounded-lg shadow-lg p-3" data-id="element-108">
          <p className="text-sm text-gray-600" data-id="element-109">{text}</p>
        </div>}
    </div>;
};